// FileTree.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Button,
  Checkbox,
} from "@mui/material";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";
const API_BASE_URL =
  process.env.REACT_APP_FASTAPI_URL || "https://docmorph.ivldsp.in"; // Backend URL

export default function FileTree({ onFileSelect }) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fetchFiles = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/ai/files`);
      setFiles(res.data.files || []);
    } catch (err) {
      console.error("Error fetching files:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);
  const toggleFile = (filename) => {
    setSelectedFiles((prev) =>
      prev.includes(filename)
        ? prev.filter((f) => f !== filename)
        : [...prev, filename]
    );
  };
  // ⬅️ Delete selected files
  const deleteSelectedFiles = async () => {
    if (selectedFiles.length === 0) return alert("No files selected.");

    if (!window.confirm("Delete selected files?")) return;

    try {
      const res = await axios.post(`${API_BASE_URL}/api/ai/deletefiles`, {
        files: selectedFiles,
      });

      alert("Deleted successfully!");

      // Refresh list
      fetchFiles();

      // Clear selection
      setSelectedFiles([]);
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete files");
    }
  };

  if (loading)
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Paper sx={{ p: 2, height: "80vh", overflowY: "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          color="error"
          size="small"
          disabled={selectedFiles.length === 0}
          onClick={deleteSelectedFiles}
          startIcon={<DeleteIcon />}
        ></Button>
      </Box>

      <SimpleTreeView>
        {files.map((file, index) => (
          <TreeItem
            key={file.filename}
            itemId={`${index}`}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  // cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={selectedFiles.includes(file.filename)}
                  onChange={() => toggleFile(file.filename)}
                />

                <PictureAsPdfIcon color="error" />
                <Typography
                  variant="body2"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    const pdfUrl = `${API_BASE_URL}${file.url}`;
                    const convertedPdf = file.filename.replace(".pdf", ".pdf");
                    const convertedPdfUrl = `${API_BASE_URL}/templates/${convertedPdf}`;
                    const convertedHtml = file.filename.replace(
                      ".pdf",
                      ".html"
                    );
                    const convertedHtmlUrl = `${API_BASE_URL}/templates/${convertedHtml}`;

                    onFileSelect(pdfUrl, convertedPdfUrl, convertedHtmlUrl);
                  }}
                >
                  {file.filename}
                </Typography>
              </Box>
            }
          />
        ))}
      </SimpleTreeView>
    </Paper>
  );
}
